const nhiemVuPaging = (state) => state.nhiemVuPaging;
const tatCaDonViTrongDonViCha = (state) => state.tatCaDonViTrongDonViCha;
const nhiemVuDangCapNhat = (state) => state.nhiemVuDangCapNhat;
const nhiemVuId = (state) => state.nhiemVuId;
const loaiNhiemVu = (state) => state.loaiNhiemVu;
const tatCaLoaiNhiemVu = (state) => state.tatCaLoaiNhiemVu;
const tatCacCanBoTrongDonVi = (state) => state.tatCacCanBoTrongDonVi;
const danhSachThuHoiNhiemVu = (state) => state.danhSachThuHoiNhiemVu;
const danhSachTraLaiNhiemVu = (state) => state.danhSachTraLaiNhiemVu;
const vanBanTaoNhiemVu = (state) => state.vanBanTaoNhiemVu;
const tatCaCanBoCoQuyenPhanXuLyTrongDonVi = (state) =>
  state.tatCaCanBoCoQuyenPhanXuLyTrongDonVi;
const danhSachSoLuongNhiemVu = (state) => state.danhSachSoLuongNhiemVu;
const danhSachNguoiGiaoNhiemVu = (state) => state.danhSachNguoiGiaoNhiemVu;
const danhSachNhiemVu = (state) => state.danhSachNhiemVu;
const danhSachTrangThai = (state) => state.danhSachTrangThai;
const danhSachDonViCaNhan = (state) => state.danhSachDonViCaNhan;
const danhSachChiTietVanBanLienQuan = (state) =>
  state.danhSachChiTietVanBanLienQuan;
const danhSachChiTietYkienXuLy = (state) => state.danhSachChiTietYkienXuLy;
const danhSachLichSuPhanXuLy = (state) => state.danhSachLichSuPhanXuLy;
const trangThaiTinhHinhThucHien = (state) => state.trangThaiTinhHinhThucHien;
const danhSachTinhHinhThucHienNhiemVu = (state) =>
  state.danhSachTinhHinhThucHienNhiemVu;
const danhSachTinhHinhThucHienContgViec = (state) =>
  state.danhSachTinhHinhThucHienContgViec;
const danhSachPhuongThucNhanNhiemVu = (state) =>
  state.danhSachPhuongThucNhanNhiemVu;
const danhSachLichSuTraLaiNhiemVu = (state) =>
  state.danhSachLichSuTraLaiNhiemVu;
const danhSachLichSuCapNhatTinhHinhNhiemVu = (state) =>
  state.danhSachLichSuCapNhatTinhHinhNhiemVu;
const danhSachLichSuThuHoiNhiemVu = (state) =>
  state.danhSachLichSuThuHoiNhiemVu;
const danhSachLichSuDonDocNhiemVu = (state) =>
  state.danhSachLichSuDonDocNhiemVu;
const danhSachVPCPDonDocNhiemVu = (state) =>
  state.danhSachVPCPDonDocNhiemVu;
  const danhSachVPCPDieuChinhNhiemVu = (state) =>
  state.danhSachVPCPDieuChinhNhiemVu;
  const danhSachVPCPTienDoXuLy = (state) =>
  state.danhSachVPCPTienDoXuLy;
const danhSachGuiTraVPCP = (state) =>
  state.danhSachGuiTraVPCP;
const danhSachDemLoaiNhiemVuCaNhan = (state) =>
  state.danhSachDemLoaiNhiemVuCaNhan;
const danhSachDemLoaiNhiemVuDonVi = (state) =>
  state.danhSachDemLoaiNhiemVuDonVi;
const danhSachDemLoaiCongViec = (state) => state.danhSachDemLoaiCongViec;
const danhSachSoDoLuongNhiemVu = (state) => state.danhSachSoDoLuongNhiemVu;
const danhSachDemLoaiCongViecDonVi = (state) =>
  state.danhSachDemLoaiCongViecDonVi;
const ketQuaExportDanhSachNhiemVu = (state) =>
  state.ketQuaExportDanhSachNhiemVu;
const danhSachNhiemVuFromImportFile = (state) =>
  state.danhSachNhiemVuFromImportFile;

const danhSachCotNhiemVuExport = (state) => state.danhSachCotNhiemVuExport;
const danhSachHienThiCotNhiemVu = (state) => state.danhSachHienThiCotNhiemVu;
const danhSachHienThiCotNhiemVuCapNhat = (state) =>
  state.danhSachHienThiCotNhiemVuCapNhat;
const danhSachDemLoaiCongViecDV = (state) => state.danhSachDemLoaiCongViecDV;
const DanhSachDanhMucCapNhat = (state) => state.DanhSachDanhMucCapNhat;
const DanhSachCotDanhMuc = (state) => state.DanhSachCotDanhMuc;

const danhSachTatCaDonVi = (state) => state.danhSachTatCaDonVi;
const dataFilterDashboard = (state) => state.dataFilterDashboard;
const getTabIndex = (state) => state.tabIndex;
const getTabText = (state) => state.tabText;
const getTabIndexVu = (state) => state.tabIndex;
export default {
  getTabIndex,
  DanhSachDanhMucCapNhat, 
  DanhSachCotDanhMuc,
  dataFilterDashboard,
  nhiemVuPaging,
  nhiemVuDangCapNhat,
  tatCaDonViTrongDonViCha,
  nhiemVuId,
  loaiNhiemVu,
  tatCaLoaiNhiemVu,
  tatCacCanBoTrongDonVi,
  danhSachThuHoiNhiemVu,
  danhSachTraLaiNhiemVu,
  vanBanTaoNhiemVu,
  tatCaCanBoCoQuyenPhanXuLyTrongDonVi,
  danhSachSoLuongNhiemVu,
  danhSachNguoiGiaoNhiemVu,
  danhSachNhiemVu,
  danhSachTrangThai,
  danhSachDonViCaNhan,
  danhSachChiTietVanBanLienQuan,
  danhSachChiTietYkienXuLy,
  danhSachLichSuPhanXuLy,
  trangThaiTinhHinhThucHien,
  danhSachTinhHinhThucHienNhiemVu,
  danhSachTinhHinhThucHienContgViec,
  danhSachPhuongThucNhanNhiemVu,
  danhSachLichSuTraLaiNhiemVu,
  danhSachLichSuCapNhatTinhHinhNhiemVu,
  danhSachLichSuThuHoiNhiemVu,
  danhSachLichSuDonDocNhiemVu,
  danhSachDemLoaiNhiemVuCaNhan,
  danhSachDemLoaiNhiemVuDonVi,
  danhSachDemLoaiCongViec,
  danhSachSoDoLuongNhiemVu,
  ketQuaExportDanhSachNhiemVu,
  danhSachNhiemVuFromImportFile,
  danhSachDemLoaiCongViecDonVi,
  danhSachCotNhiemVuExport,
  danhSachHienThiCotNhiemVu,
  danhSachHienThiCotNhiemVuCapNhat,
  danhSachDemLoaiCongViecDV,
  danhSachTatCaDonVi,
  danhSachVPCPDonDocNhiemVu,
  danhSachGuiTraVPCP,
  danhSachVPCPTienDoXuLy,
  danhSachVPCPDieuChinhNhiemVu,
  getTabIndexVu,
  getTabText
};
